import { baseFetchToken, baseFetchTokenFullResponse } from './BaseSaga'
import cronReportActions from '../Redux/CronReportRedux'
import { getToken } from '../Services/GetToken'

export function * getCronReport (api, action) {
  yield baseFetchTokenFullResponse(
    api.getCronReport,
    action.data,
    getToken,
    cronReportActions.getCronReportSuccess,
    cronReportActions.getCronReportFailure
  )
}

export function * getCronReportItem (api, action) {
  yield baseFetchTokenFullResponse(
    api.getCronReportItem,
    action.data,
    getToken,
    cronReportActions.getCronReportItemSuccess,
    cronReportActions.getCronReportItemFailure
  )
}

export function * disableAttraction (api, action) {
  yield baseFetchToken(
    api.disableAttraction,
    action.data,
    getToken,
    cronReportActions.disableAttractionSuccess,
    cronReportActions.disableAttractionFailure
  )
}

export function * enableAttraction (api, action) {
  yield baseFetchToken(
    api.enableAttraction,
    action.data,
    getToken,
    cronReportActions.enableAttractionSuccess,
    cronReportActions.enableAttractionFailure
  )
}

export function * getWhitelist (api, action) {
  yield baseFetchToken(
    api.getWhitelist,
    action.data,
    getToken,
    cronReportActions.getWhitelistSuccess,
    cronReportActions.getWhitelistFailure
  )
}

export function * putWhitelist (api, action) {
  yield baseFetchToken(
    api.putWhitelist,
    action.data,
    getToken,
    cronReportActions.putWhitelistSuccess,
    cronReportActions.putWhitelistFailure
  )
}

export function * deleteWhitelist (api, action) {
  yield baseFetchToken(
    api.deleteWhitelist,
    action.data,
    getToken,
    cronReportActions.deleteWhitelistSuccess,
    cronReportActions.deleteWhitelistFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/CronReportSagas.js